// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Medication as MedicationIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Warning as WarningIcon,
//   Inventory as InventoryIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const MedicationInventoryPage = () => {
//   const navigate = useNavigate();
//   const [medications, setMedications] = useState([]);
//   const [filteredMeds, setFilteredMeds] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     stock_status: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [selectedMed, setSelectedMed] = useState(null);

//   // Form Data
//   const [medForm, setMedForm] = useState({
//     name: "",
//     quantity: "",
//     expiry_date: "",
//     description: ""
//   });

//   const API_URL = "https://dairy.server.statify.co.ke/api/medications";

//   // Helper function to format date for form input
//   const formatDateForInput = (dateString) => {
//     if (!dateString || dateString === 'No expiry') return "";
    
//     try {
//       // Try parsing the date string - handle various formats
//       const date = new Date(dateString);
      
//       // Check if date is valid
//       if (isNaN(date.getTime())) {
//         console.warn('Invalid date:', dateString);
//         return "";
//       }
      
//       return date.toISOString().split('T')[0];
//     } catch (error) {
//       console.error('Error formatting date:', error, dateString);
//       return "";
//     }
//   };

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 200, label: 'Medication Name', dataKey: 'name' },
//     { width: 120, label: 'Quantity', dataKey: 'quantity' },
//     { width: 120, label: 'Expiry Date', dataKey: 'expiry_date' },
//     { width: 200, label: 'Description', dataKey: 'description' },
//     { width: 120, label: 'Stock Status', dataKey: 'stock_status' },
//     { width: 120, label: 'Expiry Status', dataKey: 'expiry_status' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Fetch Medications
//   const fetchMedications = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         const now = new Date();
//         const transformedMeds = data.map(med => {
//           const expiryDate = med.expiry_date ? new Date(med.expiry_date) : null;
          
//           // Stock status
//           let stockStatus = "In Stock";
//           let stockColor = "success";
//           if (med.quantity === 0) {
//             stockStatus = "Out of Stock";
//             stockColor = "error";
//           } else if (med.quantity < 10) {
//             stockStatus = "Low Stock";
//             stockColor = "warning";
//           }

//           // Expiry status
//           let expiryStatus = "Valid";
//           let expiryColor = "success";
//           if (expiryDate) {
//             const daysUntilExpiry = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
//             if (daysUntilExpiry < 0) {
//               expiryStatus = "Expired";
//               expiryColor = "error";
//             } else if (daysUntilExpiry <= 30) {
//               expiryStatus = "Expiring Soon";
//               expiryColor = "warning";
//             }
//           }

//           // Format expiry date for display
//           let expiryDisplay = 'No expiry';
//           try {
//             if (expiryDate && !isNaN(expiryDate.getTime())) {
//               expiryDisplay = expiryDate.toLocaleDateString();
//             }
//           } catch (err) {
//             console.error('Error formatting expiry date:', err);
//           }

//           return {
//             ...med,
//             stock_status: stockStatus,
//             stock_color: stockColor,
//             expiry_status: expiryStatus,
//             expiry_color: expiryColor,
//             expiry_date: expiryDisplay,
//             short_description: med.description ? 
//               (med.description.length > 50 ? `${med.description.substring(0, 50)}...` : med.description) 
//               : 'No description',
//             originalExpiryDate: med.expiry_date // Keep original date for editing
//           };
//         });
//         setMedications(transformedMeds);
//       } else {
//         setMedications([]);
//       }
//     } catch (err) {
//       console.error('Error fetching medications:', err);
//       swal("Error", "Failed to fetch medications", "error");
//       setMedications([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMedications();
//   }, []);

//   // Filter medications based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(medications)) {
//       setFilteredMeds([]);
//       return;
//     }
    
//     let results = medications;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(med =>
//         (med.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (med.description?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply stock status filter
//     if (filters.stock_status) {
//       results = results.filter(med => 
//         med.stock_status === filters.stock_status
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (sortConfig.key === 'expiry_date') {
//           try {
//             const aDate = new Date(a.originalExpiryDate || a.expiry_date);
//             const bDate = new Date(b.originalExpiryDate || b.expiry_date);
            
//             if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            
//             return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
//           } catch (err) {
//             return 0;
//           }
//         }
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredMeds(results);
//   }, [medications, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       stock_status: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setMedForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setMedForm({
//       name: "",
//       quantity: "",
//       expiry_date: "",
//       description: ""
//     });
//   };

//   // Create Medication
//   const handleCreateMedication = async () => {
//     if (!medForm.name || !medForm.quantity) {
//       swal("Error", "Medication name and quantity are required", "error");
//       return;
//     }

//     if (medForm.quantity < 0) {
//       swal("Error", "Quantity cannot be negative", "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...medForm,
//           quantity: parseFloat(medForm.quantity)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Medication added successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchMedications();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Medication
//   const handleUpdateMedication = async () => {
//     if (!selectedMed) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedMed.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...medForm,
//           quantity: parseFloat(medForm.quantity)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Medication updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedMed(null);
//         resetForm();
//         fetchMedications();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (medId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the medication!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${medId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchMedications();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (med) => {
//     setSelectedMed(med);
//     setOpenViewDialog(true);
//   };

//   // Open Edit Dialog - FIXED VERSION
//   const handleEdit = (med) => {
//     setSelectedMed(med);
    
//     // Use the helper function to safely format the expiry date
//     const formattedExpiryDate = formatDateForInput(med.originalExpiryDate || med.expiry_date);
    
//     setMedForm({
//       name: med.name,
//       quantity: med.quantity,
//       expiry_date: formattedExpiryDate,
//       description: med.description || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Get Low Stock Medications
//   const getLowStockMedications = async () => {
//     try {
//       const res = await fetch(`${API_URL}/low-stock`);
//       const data = await res.json();
//       if (Array.isArray(data)) {
//         return data;
//       }
//       return [];
//     } catch (err) {
//       console.error('Error fetching low stock medications:', err);
//       return [];
//     }
//   };

//   // Get Expired Medications
//   const getExpiredMedications = async () => {
//     try {
//       const res = await fetch(`${API_URL}/expired`);
//       const data = await res.json();
//       if (Array.isArray(data)) {
//         return data;
//       }
//       return [];
//     } catch (err) {
//       console.error('Error fetching expired medications:', err);
//       return [];
//     }
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'warning.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, med) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {med.name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {med.quantity} units
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {med.expiry_date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={med.description}>
//           {med.short_description}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={med.stock_status} 
//           size="small"
//           color={med.stock_color}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={med.expiry_status} 
//           size="small"
//           color={med.expiry_color}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(med)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(med)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(med.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'warning.dark' }}>
//         <Toolbar>
//           <MedicationIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Medication Inventory
//           </Typography>
//           <Chip 
//             label={`${medications.length} Medications`} 
//             color="primary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ borderRadius: 2, backgroundColor: 'success.main' }}
//           >
//             Add Medication
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'warning.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search medications by name or description..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="warning"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="warning">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth 
//                      sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
//                     >
//                       <InputLabel>Stock Status</InputLabel>
//                       <Select
//                         value={filters.stock_status}
//                         onChange={(e) => handleFilterChange('stock_status', e.target.value)}
//                         label="Stock Status"
//                       >
//                         <MenuItem value="">All Status</MenuItem>
//                         <MenuItem value="In Stock">In Stock</MenuItem>
//                         <MenuItem value="Low Stock">Low Stock</MenuItem>
//                         <MenuItem value="Out of Stock">Out of Stock</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
            
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="warning" />
//               </Box>
//             ) : filteredMeds.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'warning.light' }}>
//                 <CardContent>
//                   <InventoryIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
//                   <Typography variant="h5" color="warning.main" gutterBottom>
//                     No medications found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Add medications to your inventory to track stock levels and expiry dates
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="warning" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                   >
//                     Add First Medication
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'warning.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredMeds}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Medication Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <AddIcon sx={{ mr: 1 }} />
//             Add New Medication
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Medication Name *"
//                 value={medForm.name}
//                 onChange={(e) => handleFormChange('name', e.target.value)}
//                 placeholder="Enter medication name..."
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quantity *"
//                 type="number"
//                 value={medForm.quantity}
//                 onChange={(e) => handleFormChange('quantity', e.target.value)}
//                 inputProps={{ min: 0, step: 0.1 }}
//                 helperText="Current stock quantity"
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Expiry Date"
//                 type="date"
//                 value={medForm.expiry_date}
//                 onChange={(e) => handleFormChange('expiry_date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 helperText="Optional expiry date"
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Description"
//                 placeholder="Enter medication description, dosage instructions, or notes..."
//                 value={medForm.description}
//                 onChange={(e) => handleFormChange('description', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateMedication} 
//             variant="contained" 
//             color="success"
//             disabled={!medForm.name || medForm.quantity === ""}
//           >
//             Add Medication
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Medication Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             Edit Medication
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Medication Name *"
//                 value={medForm.name}
//                 onChange={(e) => handleFormChange('name', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Quantity *"
//                 type="number"
//                 value={medForm.quantity}
//                 onChange={(e) => handleFormChange('quantity', e.target.value)}
//                 inputProps={{ min: 0, step: 0.1 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Expiry Date"
//                 type="date"
//                 value={medForm.expiry_date}
//                 onChange={(e) => handleFormChange('expiry_date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Description"
//                 value={medForm.description}
//                 onChange={(e) => handleFormChange('description', e.target.value)}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateMedication} 
//             variant="contained" 
//             color="primary"
//             disabled={!medForm.name || medForm.quantity === ""}
//           >
//             Update Medication
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Medication Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1 }} />
//               Medication Details
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedMed && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Basic Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Name:</strong> {selectedMed.name}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Quantity:</strong> {selectedMed.quantity} units
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Expiry Date:</strong> {selectedMed.expiry_date}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Status
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Stock Status:</strong> 
//                       <Chip 
//                         label={selectedMed.stock_status} 
//                         size="small"
//                         color={selectedMed.stock_color}
//                         sx={{ ml: 1 }}
//                       />
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Expiry Status:</strong> 
//                       <Chip 
//                         label={selectedMed.expiry_status} 
//                         size="small"
//                         color={selectedMed.expiry_color}
//                         sx={{ ml: 1 }}
//                       />
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Description
//                     </Typography>
//                     <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                       {selectedMed.description || 'No description available'}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="warning"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default MedicationInventoryPage;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  Medication as MedicationIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Warning as WarningIcon,
  Inventory as InventoryIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const MedicationInventoryPage = () => {
  const navigate = useNavigate();
  const [medications, setMedications] = useState([]);
  const [filteredMeds, setFilteredMeds] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    stock_status: ""
  });

  // Custom color theme
  const customColors = {
    primary: '#024A59', // Dark teal
    secondary: '#FFA916', // Orange
    lightTeal: '#e6f0f2',
    lightOrange: '#fff5e6'
  };

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedMed, setSelectedMed] = useState(null);

  // Form Data
  const [medForm, setMedForm] = useState({
    name: "",
    quantity: "",
    expiry_date: "",
    description: ""
  });

  const API_URL = "https://dairy.server.statify.co.ke/api/medications";

  // Helper function to format date for form input
  const formatDateForInput = (dateString) => {
    if (!dateString || dateString === 'No expiry') return "";
    
    try {
      // Try parsing the date string - handle various formats
      const date = new Date(dateString);
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', dateString);
        return "";
      }
      
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return "";
    }
  };

  // Table Columns for Virtualized Table
  const columns = [
    { width: 200, label: 'Medication Name', dataKey: 'name' },
    { width: 120, label: 'Quantity', dataKey: 'quantity' },
    { width: 120, label: 'Expiry Date', dataKey: 'expiry_date' },
    { width: 200, label: 'Description', dataKey: 'description' },
    { width: 120, label: 'Stock Status', dataKey: 'stock_status' },
    { width: 120, label: 'Expiry Status', dataKey: 'expiry_status' },
    { width: 200, label: 'Actions', dataKey: 'actions' },
  ];

  // Fetch Medications
  const fetchMedications = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (Array.isArray(data)) {
        const now = new Date();
        const transformedMeds = data.map(med => {
          const expiryDate = med.expiry_date ? new Date(med.expiry_date) : null;
          
          // Stock status
          let stockStatus = "In Stock";
          let stockColor = "success";
          if (med.quantity === 0) {
            stockStatus = "Out of Stock";
            stockColor = "error";
          } else if (med.quantity < 10) {
            stockStatus = "Low Stock";
            stockColor = "warning";
          }

          // Expiry status
          let expiryStatus = "Valid";
          let expiryColor = "success";
          if (expiryDate) {
            const daysUntilExpiry = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
            if (daysUntilExpiry < 0) {
              expiryStatus = "Expired";
              expiryColor = "error";
            } else if (daysUntilExpiry <= 30) {
              expiryStatus = "Expiring Soon";
              expiryColor = "warning";
            }
          }

          // Format expiry date for display
          let expiryDisplay = 'No expiry';
          try {
            if (expiryDate && !isNaN(expiryDate.getTime())) {
              expiryDisplay = expiryDate.toLocaleDateString();
            }
          } catch (err) {
            console.error('Error formatting expiry date:', err);
          }

          return {
            ...med,
            stock_status: stockStatus,
            stock_color: stockColor,
            expiry_status: expiryStatus,
            expiry_color: expiryColor,
            expiry_date: expiryDisplay,
            short_description: med.description ? 
              (med.description.length > 50 ? `${med.description.substring(0, 50)}...` : med.description) 
              : 'No description',
            originalExpiryDate: med.expiry_date // Keep original date for editing
          };
        });
        setMedications(transformedMeds);
      } else {
        setMedications([]);
      }
    } catch (err) {
      console.error('Error fetching medications:', err);
      swal("Error", "Failed to fetch medications", "error");
      setMedications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedications();
  }, []);

  // Filter medications based on search and filters
  useEffect(() => {
    if (!Array.isArray(medications)) {
      setFilteredMeds([]);
      return;
    }
    
    let results = medications;

    // Apply search term
    if (searchTerm) {
      results = results.filter(med =>
        (med.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (med.description?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply stock status filter
    if (filters.stock_status) {
      results = results.filter(med => 
        med.stock_status === filters.stock_status
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (sortConfig.key === 'expiry_date') {
          try {
            const aDate = new Date(a.originalExpiryDate || a.expiry_date);
            const bDate = new Date(b.originalExpiryDate || b.expiry_date);
            
            if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            
            return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
          } catch (err) {
            return 0;
          }
        }
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredMeds(results);
  }, [medications, searchTerm, filters, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      stock_status: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setMedForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setMedForm({
      name: "",
      quantity: "",
      expiry_date: "",
      description: ""
    });
  };

  // Create Medication
  const handleCreateMedication = async () => {
    if (!medForm.name || !medForm.quantity) {
      swal("Error", "Medication name and quantity are required", "error");
      return;
    }

    if (medForm.quantity < 0) {
      swal("Error", "Quantity cannot be negative", "error");
      return;
    }

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...medForm,
          quantity: parseFloat(medForm.quantity)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Medication added successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchMedications();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Medication
  const handleUpdateMedication = async () => {
    if (!selectedMed) return;

    try {
      const res = await fetch(`${API_URL}/${selectedMed.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...medForm,
          quantity: parseFloat(medForm.quantity)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Medication updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedMed(null);
        resetForm();
        fetchMedications();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (medId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the medication!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${medId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchMedications();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler
  const handleView = (med) => {
    setSelectedMed(med);
    setOpenViewDialog(true);
  };

  // Open Edit Dialog - FIXED VERSION
  const handleEdit = (med) => {
    setSelectedMed(med);
    
    // Use the helper function to safely format the expiry date
    const formattedExpiryDate = formatDateForInput(med.originalExpiryDate || med.expiry_date);
    
    setMedForm({
      name: med.name,
      quantity: med.quantity,
      expiry_date: formattedExpiryDate,
      description: med.description || ""
    });
    setOpenEditDialog(true);
  };

  // Get Low Stock Medications
  const getLowStockMedications = async () => {
    try {
      const res = await fetch(`${API_URL}/low-stock`);
      const data = await res.json();
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    } catch (err) {
      console.error('Error fetching low stock medications:', err);
      return [];
    }
  };

  // Get Expired Medications
  const getExpiredMedications = async () => {
    try {
      const res = await fetch(`${API_URL}/expired`);
      const data = await res.json();
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    } catch (err) {
      console.error('Error fetching expired medications:', err);
      return [];
    }
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: customColors.primary, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, med) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {med.name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {med.quantity} units
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {med.expiry_date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap title={med.description}>
          {med.short_description}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={med.stock_status} 
          size="small"
          color={med.stock_color}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={med.expiry_status} 
          size="small"
          color={med.expiry_color}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleView(med)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: customColors.lightTeal,
              color: customColors.primary,
              '&:hover': { 
                backgroundColor: customColors.primary,
                color: 'white'
              }
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(med)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: customColors.lightOrange,
              color: customColors.secondary,
              '&:hover': { 
                backgroundColor: customColors.secondary,
                color: 'white'
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleDelete(med.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: 'rgba(211, 47, 47, 0.1)',
              color: 'error.main',
              '&:hover': { 
                backgroundColor: 'error.main',
                color: 'white'
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: customColors.primary }}>
        <Toolbar>
          <MedicationIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Medication Inventory
          </Typography>
          <Chip 
            label={`${medications.length} Medications`} 
            sx={{ 
              backgroundColor: customColors.secondary, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900'
              }
            }}
          >
            Add Medication
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 2, 
          border: 2, 
          borderColor: customColors.lightTeal,
          backgroundColor: customColors.lightTeal
        }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search medications by name or description..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: customColors.primary, mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? customColors.primary : 'transparent',
                      color: showFilters ? 'white' : customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: showFilters ? '#023a47' : customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth 
                     sx={{
    minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
  }}
                    >
                      <InputLabel>Stock Status</InputLabel>
                      <Select
                        value={filters.stock_status}
                        onChange={(e) => handleFilterChange('stock_status', e.target.value)}
                        label="Stock Status"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      >
                        <MenuItem value="">All Status</MenuItem>
                        <MenuItem value="In Stock">In Stock</MenuItem>
                        <MenuItem value="Low Stock">Low Stock</MenuItem>
                        <MenuItem value="Out of Stock">Out of Stock</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: customColors.primary }} />
              </Box>
            ) : filteredMeds.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: customColors.lightTeal,
                backgroundColor: 'white'
              }}>
                <CardContent>
                  <InventoryIcon sx={{ fontSize: 64, color: customColors.primary, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: customColors.primary, mb: 1 }}>
                    No medications found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Add medications to your inventory to track stock levels and expiry dates
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    sx={{
                      backgroundColor: customColors.secondary,
                      '&:hover': {
                        backgroundColor: '#e69900'
                      }
                    }}
                  >
                    Add First Medication
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: customColors.lightTeal, 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredMeds}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Medication Dialog */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AddIcon sx={{ mr: 1 }} />
            Add New Medication
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Medication Name *"
                value={medForm.name}
                onChange={(e) => handleFormChange('name', e.target.value)}
                placeholder="Enter medication name..."
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quantity *"
                type="number"
                value={medForm.quantity}
                onChange={(e) => handleFormChange('quantity', e.target.value)}
                inputProps={{ min: 0, step: 0.1 }}
                helperText="Current stock quantity"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Expiry Date"
                type="date"
                value={medForm.expiry_date}
                onChange={(e) => handleFormChange('expiry_date', e.target.value)}
                InputLabelProps={{ shrink: true }}
                helperText="Optional expiry date"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Description"
                placeholder="Enter medication description, dosage instructions, or notes..."
                value={medForm.description}
                onChange={(e) => handleFormChange('description', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenCreateDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreateMedication} 
            variant="contained" 
            sx={{
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900'
              }
            }}
            disabled={!medForm.name || medForm.quantity === ""}
          >
            Add Medication
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Medication Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EditIcon sx={{ mr: 1 }} />
            Edit Medication
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Medication Name *"
                value={medForm.name}
                onChange={(e) => handleFormChange('name', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Quantity *"
                type="number"
                value={medForm.quantity}
                onChange={(e) => handleFormChange('quantity', e.target.value)}
                inputProps={{ min: 0, step: 0.1 }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Expiry Date"
                type="date"
                value={medForm.expiry_date}
                onChange={(e) => handleFormChange('expiry_date', e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Description"
                value={medForm.description}
                onChange={(e) => handleFormChange('description', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: customColors.primary,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: customColors.primary,
                    },
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenEditDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdateMedication} 
            variant="contained" 
            sx={{
              backgroundColor: customColors.primary,
              '&:hover': {
                backgroundColor: '#023a47'
              }
            }}
            disabled={!medForm.name || medForm.quantity === ""}
          >
            Update Medication
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Medication Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1 }} />
              Medication Details
            </Box>
            <IconButton 
              onClick={() => setOpenViewDialog(false)}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedMed && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Basic Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Name:</strong> {selectedMed.name}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Quantity:</strong> {selectedMed.quantity} units
                    </Typography>
                    <Typography variant="body2">
                      <strong>Expiry Date:</strong> {selectedMed.expiry_date}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Status
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Stock Status:</strong> 
                      <Chip 
                        label={selectedMed.stock_status} 
                        size="small"
                        color={selectedMed.stock_color}
                        sx={{ ml: 1 }}
                      />
                    </Typography>
                    <Typography variant="body2">
                      <strong>Expiry Status:</strong> 
                      <Chip 
                        label={selectedMed.expiry_status} 
                        size="small"
                        color={selectedMed.expiry_color}
                        sx={{ ml: 1 }}
                      />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Description
                    </Typography>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                      {selectedMed.description || 'No description available'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenViewDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: customColors.secondary,
          color: 'white',
          '&:hover': {
            backgroundColor: '#e69900'
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default MedicationInventoryPage;